import { render, staticRenderFns } from "./QuoteRedirect.vue?vue&type=template&id=86837d1a&scoped=true&"
import script from "./QuoteRedirect.vue?vue&type=script&lang=js&"
export * from "./QuoteRedirect.vue?vue&type=script&lang=js&"
import style0 from "./QuoteRedirect.vue?vue&type=style&index=0&id=86837d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86837d1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
